import React from 'react'

import { Breadcrumb } from '@wartek-id/breadcrumb'

import styles from './Breadcrumb.module.css'

export type BreadcrumbItemDef = {
  label: string
  href: string | null
}

interface BreadcrumbProps {
  items: BreadcrumbItemDef[]
  className?: string
}

const ResponsiveBreadcrumb = ({ items, className }: BreadcrumbProps) => (
  <div className={`${styles.breadcrumb}${className ? ` ${className}` : ''}`}>
    <Breadcrumb
      collapsed={false}
      items={items.map((item, index) => ({
        href: item.href ?? '#',
        id: `${item.label}-${index}`,
        text: item.label,
      }))}
    />
  </div>
)

export default ResponsiveBreadcrumb
